<template>
  <div :class="loading ? 'cursor-wait' : ''">
    <div v-if="modal" class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center z-10">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>
      <div class="bg-white rounded-lg overflow-hidden shadow-xl transform transition-all overflow-y-auto w-1/3" role="dialog" aria-modal="true" aria-labelledby="modal-headline" style="max-height: 70vh;">
        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
          <div class="sm:flex sm:items-start">
            <div class="w-full mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">            
              <h3 class="text-md leading-6 font-medium text-blue-900" id="modal-headline">
                {{ label }} 
              </h3>
              <div class="flex flex-col px-10 xl:px-0">
                <div class="flex flex-col px-10 xl:px-0 pt-2 pb-2">
                  <input v-model="filter" v-if="type == 'date'" @change="closeModal" type="month" class="text-sm w-3/4 form-input py-2 appearance-none rounded-md focus:border-indigo-600">
                  <select v-if="type == 'select'" v-model="filter" @change="closeModal" class="text-sm w-3/4 block appearance-none bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline">
                    <option value="null" disabled>Seleccione</option>
                    <option v-for="f in filters" :key="f.id" :value="f.id">{{ f.name }}</option>
                    <option value="0" v-if="other">Otro...</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
          <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
            <button 
              @click="closeModal"
              type="button" 
              class="inline-flex justify-center bg-transparent hover:bg-red-500 text-xs text-red-700 font-semibold hover:text-white py-2 px-2 border border-red-500 hover:border-transparent rounded">
              <svg
                class="w-5 h-5 mr-2 -ml-1 text-white-400"
                fill="currentColor"
                viewBox="0 0 20 20"
              >  
                <path d="M10.185,1.417c-4.741,0-8.583,3.842-8.583,8.583c0,4.74,3.842,8.582,8.583,8.582S18.768,14.74,18.768,10C18.768,5.259,14.926,1.417,10.185,1.417 M10.185,17.68c-4.235,0-7.679-3.445-7.679-7.68c0-4.235,3.444-7.679,7.679-7.679S17.864,5.765,17.864,10C17.864,14.234,14.42,17.68,10.185,17.68 M10.824,10l2.842-2.844c0.178-0.176,0.178-0.46,0-0.637c-0.177-0.178-0.461-0.178-0.637,0l-2.844,2.841L7.341,6.52c-0.176-0.178-0.46-0.178-0.637,0c-0.178,0.176-0.178,0.461,0,0.637L9.546,10l-2.841,2.844c-0.178,0.176-0.178,0.461,0,0.637c0.178,0.178,0.459,0.178,0.637,0l2.844-2.841l2.844,2.841c0.178,0.178,0.459,0.178,0.637,0c0.178-0.176,0.178-0.461,0-0.637L10.824,10z">
                </path>
              </svg>
              Cancelar
            </button>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    modal: false,
    label: null,
    type: null,
    url: null,
    other: false
  },

  data() {
    return {
      loading: false,
      filter: null,
      filters: []
    }
  },

  watch: {
    modal (value) {
      if (value) {
        this.filters = []
        this.filter = null
        this.getFilters()
      }
    }
  },

  methods: {
    async getFilters(){
      switch(this.type) {
        case 'select':
          this.filters = await this.$http.get(`${this.url}`)
          break;
      }
    },
    closeModal() {
      this.$emit('column-filter', this.filter)
    },
  },
}
</script>

